







































































import Vue from 'vue';
import {
  getLessonType,
  LESSON_START_TYPE_AFTER_PREVIOUS_LESSON,
} from '@/core/utils/products';
import LessonType from '@/core/typings/enums/LessonType';
import { formatDate } from '@/web/utils/format';

export default Vue.extend({
  name: 'LessonsListPanel',
  props: {
    lessons: {
      type: Array as () => LessonResponse[],
    },
    isLessonsListPanelOpened: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isLessonActive(lessonId) {
      return lessonId === +this.$route.params.lesson_id;
    },
    closePanel() {
      this.$emit('changeLessonsListPanelVisibility', false);
    },
    onLessonClick(lesson) {
      if (lesson.locked) return;
      const lessonType = getLessonType(lesson);
      if (lessonType === LessonType.TEXT || lessonType === LessonType.QUIZ) {
        this.$router.replace({
          name: 'studio-lesson-non-media',
          params: {
            product_id: this.$route.params.product_id,
            lesson_id: lesson?.id,
          },
        });
      } else if (lessonType === LessonType.MEDIA) {
        this.$router.push({
          name: 'studio-lesson-media',
          params: {
            product_id: this.$route.params.product_id,
            lesson_id: lesson?.id,
            media_id: lesson?.content[0]?.id,
          },
        });
      }
    },
    formatDate(date) {
      return formatDate(date, 'date-word', '');
    },
    getLockedLessonToolTip(lesson) {
      if (!lesson.locked) return null;

      if (
        lesson.lesson_start_type === LESSON_START_TYPE_AFTER_PREVIOUS_LESSON
      ) {
        return this.$t(
          'PRODUCTS.TEXT.LESSON_AFTER_PREVIOUS_LESSON_HAS_COMPLETED'
        );
      }

      return this.$t('STUDIO.LABELS.AVAILABLE_AFTER_DATE', {
        date: this.formatDate(lesson.lesson_available_after_date),
      });
    },
  },
});
